import { hasPermission } from '@/hooks/useBackendMenu'
import { FormField } from 'global/components/Form'
import Dialog from 'global/guides/Dialog'
import { useNavigate, useParams } from 'react-router-dom'
import { faltasCadastradas } from 'service/api/endpoints/faltas-cadastradas'
import { toast } from 'sonner'
import { useStore } from 'store'
import { z } from 'zod'
import { useDigitacaoContext } from '../pages/DigitacaoLayout'
import { useUpdateDigitacaoQueryData } from '../pages/useDigitacaoData'

interface IProps {
    open: boolean
    onClose: () => void
}

export default function ExcluirFaltaCadastrada({ open, onClose }: IProps) {
    const { setQueryData } = useUpdateDigitacaoQueryData()
    const navigate = useNavigate()
    const { data } = useDigitacaoContext()
    const { id } = useParams()
    const empresaId = useStore(state => state.companyId)

    const falta = data.find(
        ({ faltaCadastrada }) => faltaCadastrada?.id === Number(id),
    )?.faltaCadastrada

    const { mutateAsync, isLoading } =
        faltasCadastradas.mutations.useSoftDelete({
            invalidateQuery: true,
            onSuccess: async () => {
                setQueryData(
                    'FALTA_CADASTRADA',
                    {
                        ...falta!,
                        deletedAt: new Date(),
                    },
                    true,
                )
                toast.success('Falta excluída com sucesso')
                navigate(-1)
            },
            onError: e => {
                toast.error(e.message)
            },
        })

    if (!falta) return null

    return (
        <Dialog.Root
            onSubmit={({ motivo }) =>
                mutateAsync({
                    id,
                    motivo,
                    empresaId,
                } as any)
            }
            height="auto"
            schema={z.object({
                motivo: z.string().trim().min(1, 'Campo obrigatório'),
            })}
            loading={isLoading}
            open={
                open &&
                hasPermission(['delete', 'FaltasJustificadasOuInjustificadas'])
            }
            onClose={onClose}
        >
            <Dialog.Title>Tem certeza que deseja excluir a falta?</Dialog.Title>
            <Dialog.Content dividers>
                <FormField
                    name="motivo"
                    label="Motivo"
                    required
                    multiline
                    rows={4}
                    max={150}
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton color="error" closeOnSubmit>
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
